export const DATE_FORMAT = 'DD.MM.YYYY';

export const DATE_FORMAT_US = 'MM.DD.YYYY';
